import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FunctionGetDataFromS3 } from "../utils/useFunction";

export const LoadBannerFromS3 = createAsyncThunk(
  "loadBanner/data",
  async () => {
    const jsonDataBanner = await FunctionGetDataFromS3("static-banner.json");

    return {
      banner: jsonDataBanner,
    };
  }
);

const initialState = {
  banner: null,
};

const bannerSlice = createSlice({
  name: "loadฺBanner",
  initialState,
  extraReducers: {
    [LoadBannerFromS3.fulfilled]: (state, action) => {
      state.banner = action.payload.banner;
    },
  },
});

export default bannerSlice.reducer;
